import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { Logo } from "../components/Logo";
import { HeroIllustration } from "../components/HeroIllustration";

export function LandingPage() {
  const { user } = useAuth();
  const dashHref =
    user?.role === "instructor" ? "/tutor" : user?.role === "admin" ? "/admin" : "/learn";

  return (
    <div className="landing">
      <section className="hero">
        <div className="hero-copy">
        <div className="hero-badge">
          <Logo size={20} /> CAPS FET · Grades 10–12
        </div>
        <h1 className="hero-title">
          Learn by <span className="hero-accent">explaining</span>,<br />
          not memorising.
        </h1>
        <p className="hero-sub">
          PyDialog helps South African learners build real understanding through
          guided dialogue aligned with the CAPS curriculum. Explain your thinking
          in your own words and get feedback on your reasoning — when you choose
          AI marking, the marker looks beyond keywords to assess understanding.
        </p>

        <div className="hero-actions">
          {user ? (
            <Link to={dashHref} className="btn btn-primary btn-lg">
              Go to your dashboard →
            </Link>
          ) : (
            <>
              <Link to="/register" className="btn btn-primary btn-lg">
                Get started — it's free
              </Link>
              <Link to="/login" className="btn btn-secondary btn-lg">
                Sign in
              </Link>
            </>
          )}
        </div>
        <p className="hero-note">Mathematical Literacy · Mathematics · Accounting · English HL &amp; FAL</p>
        </div>
        <HeroIllustration />
      </section>

      <section className="feature-grid">
        <div className="feature-card">
          <span className="feature-eyebrow">Assessment</span>
          <h3>Understanding, not guessing</h3>
          <p>
            Answers are assessed for genuine reasoning at the appropriate level
            of Bloom's Taxonomy. Clear explanations are rewarded; keyword
            stuffing is not.
          </p>
        </div>
        <div className="feature-card">
          <span className="feature-eyebrow">Figures</span>
          <h3>Maths diagrams you can trust</h3>
          <p>
            Graphs and geometry are rendered accurately inside each question,
            including parabolas, circles, and geometric diagrams.
          </p>
        </div>
        <div className="feature-card">
          <span className="feature-eyebrow">Progress</span>
          <h3>See your mastery grow</h3>
          <p>
            Track progress by objective, identify misconceptions, and give
            instructors a clear view of each learner's development over time.
          </p>
        </div>
      </section>
    </div>
  );
}
